import React, { Fragment, useState, useEffect } from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { ReusableInput } from 'Components/Reusable/Inputs/ReusableInput';
import { CommonButton } from 'Components/Reusable/Buttons/Buttons';
import loginBottomFooterWeb from 'Assets/img/svg/loginBottomFooterWeb.svg';
import loginBTopHeaderWeb from 'Assets/img/svg/loginTopHeaderWeb.svg';
import verticalLogo from 'Assets/img/svg/verticalLogo.svg';
import { useStyles } from './login.style';
import { RootState } from '../../../ReduxStore/store';
import { useDispatch, useSelector } from 'react-redux';
import { loginAction } from '../../../ReduxStore/user';
import { useHistory, withRouter } from 'react-router-dom';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { Routes } from 'Utils';
import { FadeInLeft, FadeIn } from 'Animation/Animations';
import ClipLoader from 'react-spinners/ClipLoader';
import 'animate.css';
import { Bounce } from 'react-awesome-reveal';
interface State {
	password: string;
	showPassword: boolean;
}

const validationSchema = yup.object({
	email: yup.string().email('Enter a valid email').required('Email is required'),
	password: yup.string().min(8, 'Password needs to be 8 or more characters').required('Password is required'),
});

const Login = () => {
	const classes = useStyles();
	const [values, setValues] = useState<State>({
		password: '',
		showPassword: false,
	});
	const [loading, setLoading] = useState(true);
	const [redirectionAnother, setRedirectionAnother] = useState(false)
	const dispatch = useDispatch();
	const matches = useMediaQuery('(max-width:440px)');

	const todos: any = useSelector((state: RootState) => state.users['login']);
	const errors: any = useSelector((state: RootState) => state.users['errors']);
	const history = useHistory();

	const welcome = todos?.data.userExists.isWelcome;
	

	const formik = useFormik({
		initialValues: {
			email: '',
			password: '',
		},
		validationSchema: validationSchema,
		onSubmit: async values => {
			setLoading(todos?.loading);
			dispatch(loginAction(values.email, values.password));
			// setTimeout(() => {		
			// 	if (localStorage.getItem('token')  != undefined){

			// 		// eslint-disable-next-line no-console
			// 		console.log(welcome,"--->")
			// 		return welcome && !welcome ? history.push(Routes.Welcome) : history.push(Routes.Menu);
			// 	}
			// 	return history.push(Routes.Login)
			// }, 3000);
			
		},
	});
	const loginElements = [
		{
			id: 1,
			name: 'email',
			label: 'Email',
			type: 'email',
			placeholder: '',
			beforeLink: '',
			link: '#',
			textLink: '',
		},
		{
			id: 2,
			name: 'password',
			type: 'password',
			placeholder: '',
			beforeLink: '',
			link: Routes.forgotPassword,
			textLink: 'Forgot Password ?',
			label: 'Password',
		},
	];
	useEffect(() => {
		setTimeout(() => {			
		if(localStorage.getItem('token') != undefined){
			return welcome === false ? history.push(Routes.Welcome) : history.push(Routes.Menu);
		}
		
		return history.push(Routes.Login)
	}, 3000);
	
	}, [])
	const goToSignUp = () => {
		setRedirectionAnother(true)
		return window.open(Routes.Signup,"_self");
		
	};

	return (
		<Fragment>
			<div className={classes.loginSection}>
				<img src={loginBTopHeaderWeb} alt="" className="position-fixed top-0 w-100" />
				<section className="d-flex flex-column align-items-center zindex-modal flex-wrap justify-content-center position-absolute top-50 start-50 translate-middle">
					<FadeIn>
						<img src={verticalLogo} alt="" />
					</FadeIn>
					<div className="">
						{errors && errors.message != null ? (
							<div className="d-flex justify-content-center pt-3 alert alert-danger">
								<span className={classes.error}>{errors.message}</span>
							</div>
						) : (
							''
						)}
						<form onSubmit={formik.handleSubmit}>
							<ul className={`${classes.listItems} m-0 p-0 `}>
								{loginElements.map(element => (
									<li key={element.id} className="mt-4">
										<FadeInLeft>
											<ReusableInput
												name={element.name}
												type={element.type}
												placeholder={element.placeholder}
												formik={formik}
												label={element.label}
												link={element.link}
												width={matches ? '240.17px' : '383.79px'}
												height="53.91px"
												textLink={element.textLink}
												beforeLinkText={element.beforeLink}
											/>
										</FadeInLeft>
									</li>
								))}
							</ul>
							<div className="d-flex flex-column">
								<Bounce>
									<CommonButton
										command={
											loading ? (
												'LOGIN'
											) : errors?.message ? (
												'LOGIN'
											) : (
												<ClipLoader color={'white'} loading={true} size={30} />
											)
										}
										common={{
											width: matches ? '241px' : '381.87px',
											height: '48px',
											background: '#7FD6DD',
											radius: '200px',
											color: 'white',
										}}
									/>
								</Bounce>
								<div className={classes.link}>
									<span
										className="text-capitalize float-end"
										style={{ fontSize: '14px', fontFamily: 'Poppins' }}
									>
										<span className="px-2 wow bounceIn">New User?</span>
										<span
											style={{ color: '#FF7552', fontSize: '14px', cursor: 'pointer' }}
											onClick={() => goToSignUp()}
										>
											Register
										</span>
									</span>
								</div>
							</div>
						</form>
					</div>
				</section>
				<img
					src={loginBottomFooterWeb}
					alt=""
					className="position-fixed bottom-0 w-100"
					style={{ zIndex: -1 }}
				/>
			</div>
		</Fragment>
	);
};

export default withRouter(Login);
